import { createContext } from 'react'
import { JWT } from 'configs/JWT'

export const defaultUserData = {
	user: {
		id: '',
		firstName: '',
		lastName: '',
		email: '',
		catalogTypes: [],
		contractsFilter: [],
		forcePasswordChange: false,
		hasAcceptedLatestTermsOfUse: true,
		hasSelectedContracts: false,
		hasPendingLicenseAgreements: false,
		helpFile: undefined,
		isKasseUser: false,
		isSuperuser: false,
		isVswUser: false
	},
	isAuthenticated: !!JWT.get(),
	error: undefined,
	loadingAuth: false,
	loadingVerify: false,
	hasToken: false,
	login: () => {},
	logout: () => {},
	refetchMe: () => {}
}

export default createContext(defaultUserData)
